import { useTranslation } from 'react-i18next';
import { constantStrings } from '../../../../../constantStrings';
import PieCharts from '../../../../Recharts/PieCharts';
import { FormHeading, FormPrimaryContainer } from '../../../../styles';
import GenericHeadingText from '../../../../UIComponents/GenericHeading';
import { getOrderedData } from '../../../../../CommonUtilities';

const CertificationLevelComponent = ({ filteredBuildingData }: any) => {
    const { t } = useTranslation();

    const certificationsPerLevelData = filteredBuildingData.buildingData.reduce(
        (acc: any, data: any) => {
            const level = data.certificationLevel;

            let levelObject = acc.find((item: any) => item.name === level);

            if (!levelObject) {
                levelObject = {
                    name: level,
                    value: 0
                };
                acc.push(levelObject);
            }

            levelObject['value']++;

            return acc;
        },
        []
    );

    const showData = () => {
        if (!certificationsPerLevelData.length)
            return (
                <GenericHeadingText
                    title={t(constantStrings.noInformationAvailable)}
                    className='col-3 mb-1'
                />
            );

        return (
            <PieCharts
                pieChartData={getOrderedData(
                    certificationsPerLevelData,
                    filteredBuildingData.certificationLevels
                )}
                innerRadius={0}
                outerRadius={110}
                key={'level'}
                containerHeight={450}
            />
        );
    };

    return (
        <FormPrimaryContainer className='col-12 flex-fill h-100' border={true}>
            <FormHeading> {t(constantStrings.certificationLevel)}</FormHeading>
            {showData()}
        </FormPrimaryContainer>
    );
};

export default CertificationLevelComponent;
